import React from "react";
import { Carousel } from "react-bootstrap";
import HomePageLogo from "../../images/HomePage.jpeg";
import planningOne from "../../images/image001.jpeg";
import planningTwo from "../../images/image002.jpeg";
import planningThree from "../../images/image003.jpeg";
import planningFour from "../../images/image004.jpeg";
import { useAuth } from "../providers/AuthProvider";

const NavBarHomePage: React.FC = () => {
  const transportationUserDescription = (
    <p className="mb-3">
      Domestic Business Partners, welcome to our Custom Vendor Portal (CVP), a
      critical component to the Purchase Order fulfillment process for Dollar
      Tree. Your timely, accurate and complete entry of the required information
      as you create order releases is the foundation of an efficient supply
      chain process to get your products to market. The CVP toolset, supporting
      guides and tutorials will enable you to successfully complete all needed
      information. Your compliance is essential and appreciated.
    </p>
  );

  const financeUserDescription = (
    <p className="mb-3">
      The CVP program can also be used as a valuable resource for viewing and
      monitoring payment status. Users can access the program to determine where
      a payment is in the process, confirm whether a payment has been issued,
      and obtain relevant payment information. Utilizing CVP provides greater
      visibility into payment activity and can help reduce unnecessary follow-up
      by allowing users to quickly check the status of a payment.
    </p>
  );
  const { roles = [] } = useAuth();

  const hasAccess = (allowedRoles: string[]) => {
    if (!allowedRoles || allowedRoles?.length === 0) return true;
    return allowedRoles?.some((role) => roles?.includes(role));
  };

  const MERCH_FINANCE_ROLES = ["ROLE_VendorFinanceUser"];
  const MERCH_ADMIN_ROLES = ["ROLE_VendorFinanceMerchAdmin"];

  const isMerchFinanceUser = hasAccess(MERCH_FINANCE_ROLES);
  const isMerchFinanceAdmin = hasAccess(MERCH_ADMIN_ROLES);

  const renderHomePageDescription = () => {
    if (isMerchFinanceAdmin || isMerchFinanceUser) {
      return financeUserDescription;
    }

    return transportationUserDescription;
  };

  return (
    <>
      <body>
        <div id="navBarHomePage" className="pageContent-style">
          <section className="page-section clearfix">
            <div className="container">
              <div className="intro">
                <img
                  className="intro-img img-fluid mb-3 mb-lg-0 rounded"
                  src={HomePageLogo}
                  alt="..."
                />
                <div className="intro-text left-0 text-center bg-faded p-5 rounded">
                  <h2 className="section-heading mb-4">
                    <span className="section-heading-lower">
                      WELCOME TO CVP
                    </span>
                  </h2>
                  {renderHomePageDescription()}
                </div>
              </div>
            </div>
          </section>
          <section className="page-section cta">
            <div className="container">
              <div className="row">
                <div className="top-content">
                  <div className="container-fluid">
                    <div
                      id="demo"
                      className="carousel slide carousel-fade"
                      data-ride="carousel"
                    >
                      <div className="container carousel-inner no-padding">
                        <Carousel nextLabel="" prevLabel="">
                          <Carousel.Item className="carousel-item">
                            <div className="col-xs-3 col-sm-3 col-md-3">
                              <img src={planningOne} alt="..." />
                            </div>
                            <div className="col-xs-3 col-sm-3 col-md-3">
                              <img src={planningTwo} alt="..." />
                            </div>
                            <div className="col-xs-3 col-sm-3 col-md-3">
                              <img src={planningThree} alt="..." />
                            </div>
                            <div className="col-xs-3 col-sm-3 col-md-3">
                              <img src={planningFour} alt="..." />
                            </div>
                          </Carousel.Item>
                          <Carousel.Item className="carousel-item ">
                            <div className="col-xs-3 col-sm-3 col-md-3">
                              <img src={planningTwo} alt="..." />
                            </div>
                            <div className="col-xs-3 col-sm-3 col-md-3">
                              <img src={planningThree} alt="..." />
                            </div>
                            <div className="col-xs-3 col-sm-3 col-md-3">
                              <img src={planningFour} alt="..." />
                            </div>
                            <div className="col-xs-3 col-sm-3 col-md-3">
                              <img src={planningOne} alt="..." />
                            </div>
                          </Carousel.Item>
                          <Carousel.Item className="carousel-item ">
                            <div className="col-xs-3 col-sm-3 col-md-3">
                              <img src={planningThree} alt="..." />
                            </div>
                            <div className="col-xs-3 col-sm-3 col-md-3">
                              <img src={planningFour} alt="..." />
                            </div>
                            <div className="col-xs-3 col-sm-3 col-md-3">
                              <img src={planningOne} alt="..." />
                            </div>
                            <div className="col-xs-3 col-sm-3 col-md-3">
                              <img src={planningTwo} alt="..." />
                            </div>
                          </Carousel.Item>
                          <Carousel.Item className="carousel-item">
                            <div className="col-xs-3 col-sm-3 col-md-3">
                              <img src={planningFour} alt="..." />
                            </div>
                            <div className="col-xs-3 col-sm-3 col-md-3">
                              <img src={planningOne} alt="..." />
                            </div>
                            <div className="col-xs-3 col-sm-3 col-md-3">
                              <img src={planningTwo} alt="..." />
                            </div>
                            <div className="col-xs-3 col-sm-3 col-md-3">
                              <img src={planningThree} alt="..." />
                            </div>
                          </Carousel.Item>
                        </Carousel>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </body>
    </>
  );
};

export default NavBarHomePage;
